import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { routes } from "../constants/routes";
import { VIEWS } from "../constants/global";

const router = createBrowserRouter([
  {
    path: routes[VIEWS.LAYOUT].fullPath,
    element: routes[VIEWS.LAYOUT].element,
    children: [
      {
        path: routes[VIEWS.HOME].fullPath,
        element: routes[VIEWS.HOME].element,
        handle: {},
      },
      {
        path: routes[VIEWS.SERVICES].fullPath,
        element: routes[VIEWS.SERVICES].element,
        handle: {},
      },
      {
        path: routes[VIEWS.OUR_WORK].fullPath,
        element: routes[VIEWS.OUR_WORK].element,
        handle: {},
      },
      {
        path: routes[VIEWS.ABOUT_US].fullPath,
        element: routes[VIEWS.ABOUT_US].element,
        handle: {},
      },
      {
        path: routes[VIEWS.COMPONENT_SHOWCASE].fullPath,
        element: routes[VIEWS.COMPONENT_SHOWCASE].element,
        handle: {},
      },
      {
        path: routes[VIEWS.CONTACT].fullPath,
        element: routes[VIEWS.CONTACT].element,
        handle: {},
      },
      {
        path: routes[VIEWS.BLOG].fullPath,
        element: routes[VIEWS.BLOG].element,
        handle: {},
      },
      {
        path: routes[VIEWS.BLOG_DETAILS].fullPath,
        element: routes[VIEWS.BLOG_DETAILS].element,
        handle: {},
      },
      {
        path: routes[VIEWS.CASE_DETAILS].fullPath,
        element: routes[VIEWS.CASE_DETAILS].element,
        handle: {},
      },
      {
        path: routes[VIEWS.LEGAL_PAGE].fullPath,
        element: routes[VIEWS.LEGAL_PAGE].element,
        handle: {},
      },
    ],
  },
]);

const Routing = () => {
  return <RouterProvider router={router} />;
};

export default Routing;
